import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createAxiosInstanceOrder,
  orderManagementApiRequest,
} from "../utils/request";
import { InstoreFlipsApis } from "../utils/apis";

export const listAllInstoreFlips = createAsyncThunk(
  "listAllInstoreFlipsCooks",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        InstoreFlipsApis.getAllInstoreflips
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listInstoreFlipsById = createAsyncThunk(
  "listAllInstoreFlipsCooks",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();

      const response = await axiosInstance.get(
        `${InstoreFlipsApis.getInstoreflipsById}?${payload.instore_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createInstoreFlips = createAsyncThunk(
  "createInstoreFlipsCooks",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();

      const response = await axiosInstance.post(
        InstoreFlipsApis.createInstoreflips,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateInstoreFlips = createAsyncThunk(
  "updateInstoreFlipsCooks",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        InstoreFlipsApis.updateInstoreflips,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateInstoreFlipsStatus = createAsyncThunk(
  "updateInstoreFlipsCooksStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        InstoreFlipsApis.updateStatusInstoreflips,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getApprovedQtyISF = createAsyncThunk(
  "getApprovedQtyISF",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${InstoreFlipsApis.getApprovedQtyISF}?id=${payload?.id}`,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const InStoreFLipsSlice = createSlice({
  name: "InstoreFlips",
  initialState: {
    prequote: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createInstoreFlips.pending, (state) => {
        state.loading = true;
      })
      .addCase(createInstoreFlips.fulfilled, (state, action) => {
        state.loading = false;
        state.quote = action.payload;
      })
      .addCase(createInstoreFlips.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default InStoreFLipsSlice.reducer;
